import { __decorate } from "tslib";
import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { map } from "rxjs";
import { ApiOrganisationConstants } from "../../../shared/constants/api-constants/api-organisation.constants";
import { ApiModuleConstants } from "../../../shared/constants/api-constants/api-module.constants";
export let NavPanService = class NavPanService {
    http;
    constructor(http) {
        this.http = http;
    }
    getMunicipalities() {
        const params = { $filter: `Modules/any(m: m/enableAFLAPortal eq true) ` };
        return this.http.get(ApiOrganisationConstants.URL, { params }).pipe(map(result => {
            const newResult = result.value.sort((a, b) => 0 - (a.name.toLowerCase() > b.name.toLowerCase() ? -1 : 1));
            return newResult;
        }));
    }
    getApplicationTypes(organisationId) {
        const params = {
            organisationId
        };
        return this.http.get(ApiModuleConstants.URL + "/" + ApiModuleConstants.GET_PORTAL_MODULES, { params }).pipe(map(result => {
            const newResult = result.value.sort((a, b) => 0 - (a.name.toLowerCase() > b.name.toLowerCase() ? -1 : 1));
            return newResult;
        }));
    }
    static ctorParameters = () => [
        { type: HttpClient }
    ];
};
NavPanService = __decorate([
    Injectable({
        providedIn: "root",
    })
], NavPanService);
